// Avatar personalizzato in localStorage ('customAvatar'), sempre in piccolo.
//
// Prima la foto scelta finiva in localStorage cosi' com'era, in base64: una foto
// del telefono sono diversi MB e la localStorage ne ha circa 5 in tutto. Piena
// quella, Firestore (persistentMultipleTabManager tiene li' lo stato condiviso tra
// le schede) falliva con "INTERNAL ASSERTION FAILED ... QuotaExceededError" e
// smetteva di sincronizzare: ogni dispositivo restava con il proprio "Continua a
// guardare" e i dispositivi non si allineavano piu'.
//
// Questo modulo va importato per primo in main.jsx: il controllo qui sotto libera
// lo spazio prima che Firestore venga inizializzato.

const AVATAR_KEY = 'customAvatar';
const AVATAR_SIZE = 256;
// Un JPEG 256x256 sta sui 20-40 KB in base64: oltre questa soglia è una foto originale.
const MAX_STORED_CHARS = 150 * 1024;

const loadImage = (src) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Immagine non leggibile'));
    img.src = src;
});

// Ritaglio quadrato centrato, ridotto ad AVATAR_SIZE: l'avatar è sempre mostrato tondo.
export async function compressAvatar(src) {
    const img = await loadImage(src);
    const side = Math.min(img.naturalWidth, img.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = AVATAR_SIZE;
    canvas.height = AVATAR_SIZE;
    canvas.getContext('2d').drawImage(
        img,
        (img.naturalWidth - side) / 2, (img.naturalHeight - side) / 2, side, side,
        0, 0, AVATAR_SIZE, AVATAR_SIZE
    );
    return canvas.toDataURL('image/jpeg', 0.85);
}

export function saveAvatar(dataUrl) {
    try {
        localStorage.setItem(AVATAR_KEY, dataUrl);
    } catch (error) {
        console.error('Avatar non salvato', error);
    }
    window.dispatchEvent(new Event('avatar-updated'));
}

// Avatar salvati dalle versioni precedenti: si tolgono subito (sincrono, prima di
// Firestore) e si rimettono ridotti appena l'immagine è decodificata.
try {
    const stored = localStorage.getItem(AVATAR_KEY);
    if (stored && stored.length > MAX_STORED_CHARS) {
        localStorage.removeItem(AVATAR_KEY);
        compressAvatar(stored).then(saveAvatar).catch(() => {});
    }
} catch {
    // localStorage non disponibile: niente da liberare
}
